export { Link, type LinkProps } from './Link';
export { linkVariants, type LinkVariantProps } from './link.variants';
